import React, { useState } from "react";
import "./FeeManagement.css";
import { FaMoneyBillWave, FaSearch, FaPlus, FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

const FeeManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [records] = useState([
    { id: "INV-001", student: "Aarav Sharma", class: "Nursery", amount: "₹15,000", status: "Paid", dueDate: "2026-04-10" },
    { id: "INV-002", student: "Ananya Patel", class: "LKG", amount: "₹18,000", status: "Pending", dueDate: "2026-05-01" },
    { id: "INV-003", student: "Rohan Verma", class: "UKG", amount: "₹18,000", status: "Overdue", dueDate: "2026-03-15" },
  ]);

  const filteredRecords = records.filter(
    (item) =>
      item.student.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="fee-container">
      <div className="fee-header">
        <h2><FaMoneyBillWave /> Fee Management & Invoicing</h2>
        <button className="btn-primary"><FaPlus /> Create Invoice</button>
      </div>

      <div className="fee-search-bar">
        <FaSearch className="search-icon" />
        <input
          type="text"
          placeholder="Search by student name or invoice ID..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="table-responsive">
        <table className="fee-table">
          <thead>
            <tr>
              <th>Invoice ID</th>
              <th>Student</th>
              <th>Class</th>
              <th>Amount</th>
              <th>Due Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredRecords.map((item) => (
              <tr key={item.id}>
                <td><strong>{item.id}</strong></td>
                <td>{item.student}</td>
                <td>{item.class}</td>
                <td>{item.amount}</td>
                <td>{item.dueDate}</td>
                <td>
                  <span className={`status-badge ${item.status.toLowerCase()}`}>
                    {item.status === "Paid" ? <FaCheckCircle /> : <FaExclamationTriangle />}
                    {item.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FeeManagement;